.root {
    padding: 0;
}

.empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-bottom: 1px solid var(--border-color);
}

.emptyText {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    text-align: center;
}
